import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteLunaProfile } from '../../../apiclients/streamsapi_bridge';
import { MDBAlert, MDBIcon } from 'mdb-react-ui-kit';

const RemoveLunaProfile = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [internalError, setInternalError] = useState(false);


    async function removeThisProfile() {

        try {
            setInternalError(false);
            props.setIsloading(true);
            let deleteReponse = await deleteLunaProfile(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.lunaId);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteReponse.json();
            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                window.location.href = "/luna-landing"
                props.onClose();

            } else if (delInfo.status == 400) {
                localStorage.setItem("f_message", delInfo.message);
                window.location.href = "/luna-landing"

            } else if (delInfo.status == 500) {
                setInternalError(true);
            }

        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    return (
        <>

            {(props.assocCFData && props.assocCFData.length > 0) ?
                <>
                    {props.assocCFData && props.assocCFData.length > 0 && (
                        <div>
                            <span className="phrecording">{t("user_associated_cflows")}<br />{props.assocCFData?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()} </span>
                        </div>
                    )}
                    <div style={{ display: "none" }}>
                        <button ref={ref} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.onClose();
                        }}>
                            {t("okay")}</button>
                    </div>
                </>
                :
                (
                    <div>
                        <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                            <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                            <span>{t("removeLunaProfile")}</span>
                        </div>
                        <div style={{ display: "none" }}>
                            <button ref={ref} onClick={(e) => { e.preventDefault(); removeThisProfile() }}>
                                {t("add")}</button>
                        </div>
                        {internalError && (<MDBAlert
                            open
                            className="alert-center"
                            color="danger"
                            autohide
                            position="bottom-right"
                            delay={5000}
                        >Internal Server Error</MDBAlert>)}
                    </div>
                )
            }


        </>
    )
});

export default RemoveLunaProfile;
